import { createConfig, http } from "wagmi";
import { base } from "wagmi/chains";
import {
  walletConnectWallet,
  rainbowWallet,
} from "@rainbow-me/rainbowkit/wallets";

import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import { env } from "@/config";

const connectors = connectorsForWallets(
  [
    {
      groupName: "Recommended",
      wallets: [walletConnectWallet, rainbowWallet],
    },
  ],
  {
    appName: "Bitton App",
    projectId: env.reownProject,
  }
);

export const wagmiConfig = createConfig({
  chains: [base],
  transports: {
    [base.id]: http(),
  },
  connectors,
  ssr: false,
});
